module.exports = __webpack_public_path__ + "img/userconnection.0c1eeb3a.svg";